// import Vue from "vue";
// import { checkResponse } from "@/helpers/store";

const state = {
  errorPaymentsModal: false,
  errorPaymentsSearchParams: null
};

const mutations = {
  setErrorPaymentsModal: (state, payload) =>
    (state.errorPaymentsModal = payload),
  setErrorPaymentsSearchParams: (state, payload) =>
    (state.errorPaymentsSearchParams = payload),
  clearErrorPaymentsSearchParams: state =>
    (state.errorPaymentsSearchParams = null)
};

const actions = {};

const getters = {
  errorPaymentsModal: state => state.errorPaymentsModal,
  errorPaymentsSearchParams: state => state.errorPaymentsSearchParams
};

export default { state, mutations, actions, getters };
